import VEHICLES from '../data/VEHICLES';
export function normalizeFossilVehicleUpdate({
  workingVehicleSet,
  newData,
  findArchetypeById,
  transformArchetypeToFossilVehicle,
}) {
  if (newData.fossilVehicle) {
    return {
      ...workingVehicleSet,
      ...newData,
      fossilVehicleId: newData.fossilVehicle.id,
    };
  }

  // Try VEHICLES lookup by vehicle_id first
  if (newData.vehicle_id) {
    const catalogVehicle = VEHICLES.find((v) => v.id === newData.vehicle_id);
    if (catalogVehicle) {
      const fossilVehicle = transformArchetypeToFossilVehicle(catalogVehicle);
      if (fossilVehicle && fossilVehicle.id) {
        return {
          ...workingVehicleSet,
          fossilVehicle,
          fossilVehicleId: fossilVehicle.id,
        };
      }
    }
  }

  // Fallback to fossilVehicleId logic
  if (newData.fossilVehicleId) {
    const archetype = findArchetypeById(newData.fossilVehicleId);
    if (archetype) {
      const fossilVehicle = transformArchetypeToFossilVehicle(archetype);
      if (fossilVehicle && fossilVehicle.id) {
        return {
          ...workingVehicleSet,
          fossilVehicle,
          fossilVehicleId: fossilVehicle.id,
        };
      }
    }
    return {
      ...workingVehicleSet,
      ...newData,
      fossilVehicle: null,
      fossilVehicleId: null,
    };
  }
  return {
    ...workingVehicleSet,
    ...newData,
  };
}
